var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.166 13.22a.85.85 0 00-1.165 1.238l3.625 3.41a.85.85 0 001.165 0l3.625-3.41a.85.85 0 00-1.165-1.239l-2.192 2.064V5.418c0-.532.43-.963.962-.963a.85.85 0 000-1.7 2.662 2.662 0 00-2.663 2.663v9.864L4.167 13.22zm7.25-6.437a.85.85 0 01-1.165-1.238l3.625-3.411a.85.85 0 011.165 0l3.624 3.41A.85.85 0 1117.5 6.784L15.308 4.72v10.717a2.662 2.662 0 01-2.662 2.663.85.85 0 010-1.7c.531 0 .962-.431.962-.963V4.72l-2.192 2.063z",
    fill: "currentColor"
  })));
}
export default SvgTrade;